import $ = require("jquery");
import ko = require("knockout");
import _ = require("underscore");
import svc = require("../Atlas/Service");

export = CrnTermCodePicker;


namespace CrnTermCodePicker {

    export interface ICrnTermCodePickerParams {
        externalVm?: any;
        crn?: KnockoutObservable<string>;
        selectedTerm?: KnockoutObservable<string>;
        isValid?: KnockoutObservable<boolean>;
        validationMessage?: KnockoutObservable<string>;
        resolvedCampusSection?: KnockoutObservable<ICampusSection>;
        focused?: KnockoutObservable<boolean>;
        lookupUrl?: string;
        terms?: ITextValue[];
        forcedTerm?: ITextValue;
        placeholderText?: KnockoutObservable<string>;
        id?: string;
        disableValidation?: boolean;

        crnInputLabel?: KnockoutObservable<string>; //Custom label to place on the CRN input field
        termSelectLabel?: KnockoutObservable<string>; //Custom label to place on the term select input field
        inputGroupLabel?: KnockoutObservable<string>; //Custom fieldset legend for the crn termcode picker inputs
        displayGroupLabel: KnockoutObservable<boolean>; //display (or not) the inputGroupLabel fieldset legend for the component
        groupLabelCssClasses: KnockoutObservable<string>; //when displaying the group label, what classes to add to the fieldset legend

        resolutionIdSuffix?: KnockoutObservable<string>; //Added to the end of the id of the resolved info.  Needed when multiple components appear on the same page.  We used aria-described by so user sees results during input which needs an id.
    }

    export class CrnTermCodePickerViewModel {
        private externalVm: any;
        public crn: KnockoutObservable<string>;
        private isValid: KnockoutObservable<boolean>;
        public validationMessage: KnockoutObservable<string>;
        public focused: KnockoutObservable<boolean>;
        private resolvedCampusSection: KnockoutObservable<ICampusSection>;
        private lookupUrl: string;
        private terms: ITextValue[];
        private forcedTerm: ITextValue;
        public selectedTerm: KnockoutObservable<string>;
        public placeholderText: KnockoutObservable<string>;
        addCallback: (resolvedCampusSEction: ICampusSection, afterAdd: (err) => void) => void
        private usingMultipleTerms: boolean;

        public hasError: KnockoutComputed<boolean>;
        public showResolving: KnockoutComputed<boolean>;
        public showInitialState: KnockoutComputed<boolean>;
        public crnInputLabel: KnockoutObservable<string>;
        public termSelectLabel: KnockoutObservable<string>;
        public inputGroupLabel: KnockoutObservable<string>;
        public displayGroupLabel: KnockoutObservable<boolean>;
        public groupLabelCssClasses: KnockoutObservable<string>;

        id: string;
        disableValidation: boolean;
        resolvedCourseName: KnockoutComputed<string>;
        resolvedCourseDescription: KnockoutComputed<string>;
        resolutionIdSuffix: KnockoutObservable<string>;

        constructor(params: ICrnTermCodePickerParams) {
            if (params && params.lookupUrl) {
                this.lookupUrl = params.lookupUrl;
            } else {
                this.lookupUrl = svc.globalPageData().urls.resolveCrnTermCode;
            }

            if (params && params.externalVm) {
                params.externalVm(this);
            }

            if (params && params.crn && ko.isObservable(params.crn)) {
                this.crn = params.crn;
            } else {
                this.crn = ko.observable<string>();
            }

            if (params && params.isValid && ko.isObservable(params.isValid)) {
                this.isValid = params.isValid;
            } else {
                this.isValid = ko.observable(false);
            }

            if (params && params.validationMessage && ko.isObservable(params.validationMessage)) {
                this.validationMessage = params.validationMessage;
            } else {
                this.validationMessage = ko.observable("");
            }

            if (params && params.resolvedCampusSection && ko.isObservable(params.resolvedCampusSection)) {
                this.resolvedCampusSection = params.resolvedCampusSection;
            } else {
                this.resolvedCampusSection = ko.observable<ICampusSection>();
            }

            if (params && params.focused && ko.isObservable(params.focused)) {
                this.focused = params.focused;
            } else {
                this.focused = ko.observable(true);
            }

            if (params && params.terms && params.terms.length) {
                this.terms = params.terms;
            } else {
                this.terms = [];
            }

            this.selectedTerm = ko.observable(null);

            if (params && params.selectedTerm && ko.isObservable(params.selectedTerm)) {
                this.selectedTerm = params.selectedTerm;
            }

            if (params && params.forcedTerm) {
                this.forcedTerm = params.forcedTerm;
                this.selectedTerm(params.forcedTerm.Value);
                this.usingMultipleTerms = false;
            } else
                this.usingMultipleTerms = true;

            this.placeholderText = ko.observable("xxxxx");

            if (params.placeholderText) {
                this.placeholderText = params.placeholderText;
            }

            if (params && params.disableValidation) {
                this.disableValidation = true;
            }

            if (params.crnInputLabel) {
                this.crnInputLabel = params.crnInputLabel;
            } else {
                this.crnInputLabel = ko.observable("Course CRN");
            }

            if (params.termSelectLabel) {
                if (ko.isObservable(params.termSelectLabel))
                    this.termSelectLabel = params.termSelectLabel;
                else
                    this.termSelectLabel = ko.observable(params.termSelectLabel);
            } else {
                this.termSelectLabel = ko.observable("Term");
            }

            if (params.inputGroupLabel) {
                if (ko.isObservable(params.inputGroupLabel))
                    this.inputGroupLabel = params.inputGroupLabel;
                else
                    this.inputGroupLabel = ko.observable(params.inputGroupLabel);
            } else {
                let txt = "CRN and TermCode Picker";
                this.inputGroupLabel = ko.observable(txt);
            }

            if (params.displayGroupLabel) {
                if (ko.isObservable(params.displayGroupLabel))
                    this.displayGroupLabel = params.displayGroupLabel;
                else
                    this.displayGroupLabel = ko.observable(params.displayGroupLabel);
            } else {
                this.displayGroupLabel = ko.observable(false);
            }

            if (params.groupLabelCssClasses && this.displayGroupLabel()) {
                if (ko.isObservable(params.groupLabelCssClasses))
                    this.groupLabelCssClasses = params.groupLabelCssClasses;
                else
                    this.groupLabelCssClasses = ko.observable(params.groupLabelCssClasses);
            } else { //if displaying the legend, default to label class otherwise visually hide
                if (this.displayGroupLabel())
                    this.groupLabelCssClasses = ko.observable("label");
                else
                    this.groupLabelCssClasses = ko.observable("sr-only");
            }

            if (params.resolutionIdSuffix) {
                if (ko.isObservable(params.resolutionIdSuffix))
                    this.resolutionIdSuffix = params.resolutionIdSuffix;
                else
                    this.resolutionIdSuffix = ko.observable(params.resolutionIdSuffix);
            } else { //default to empty ... there should only be one control on the page in this case
                this.resolutionIdSuffix = ko.observable("");
            }

            this.resolvedCourseName = ko.pureComputed(() => {
                var cs = this.resolvedCampusSection();
                if (cs) {
                    return cs.ShortDescription;
                }
                return null;
            });

            this.resolvedCourseDescription = ko.pureComputed(() => {
                var cs = this.resolvedCampusSection();
                if (cs) {
                    return cs.Title;
                }
                return null;
            });

            this.hasError = ko.pureComputed(() => {
                if (!this.successfulResolution() && this.crn() && !this.resolving() && this.showStatus()) {
                    return true;
                }
                return false;
            });
            this.showResolving = ko.pureComputed(() => {
                return this.showQuickStatus() && (this.resolving() || (this.crn() && !this.showStatus() && !this.successfulResolution()));
            });
            this.showInitialState = ko.pureComputed(() => {
                return !this.hasError() && !this.showResolving() && !this.successfulResolution();
            });

            this.id = params.id;

            this.initComponent();
        }

        public successfulResolution = ko.observable(false);
        private showStatus = ko.observable(true);
        private showQuickStatus = ko.observable(false);
        private resolving = ko.observable(false);
        public addingEntity = ko.observable(false);
        public invalidGroupType = ko.observable(false);

        private resetEditor() {
            this.successfulResolution(false);
            this.resolvedCampusSection(null);
            this.crn(null);
            this.addingEntity(false);
            this.focused(true);
            this.invalidGroupType(false);
        }

        private setDisplayText(cs: ICampusSection) {
            this.resolving(false);
            if (cs) {
                this.resolvedCampusSection(cs);
                this.successfulResolution(true);
                return;
            }
       
            this.resolvedCampusSection(null);
            this.successfulResolution(false);
        }

        public addEntity() {
            if (this.addCallback) {
                if (this.successfulResolution()) {
                    this.addingEntity(true);
                    this.addCallback(this.resolvedCampusSection(), (err) => {
                        if (!err) {
                            this.resetEditor();
                        }
                        this.addingEntity(false);
                    });
                }
            }
        }

        private initComponent() {
            var vm = this;
            var crns: { [s: string]: ICampusSection } = {};
            var lookupXhr: JQueryXHR = null;

            function actuallyLookupValue() {
                vm.resolving(true);
                var crn = vm.crn();
                var cacheKey = crn;
                if (vm.usingMultipleTerms) {
                    cacheKey = cacheKey + "|" + vm.selectedTerm();
                } else {
                    cacheKey = cacheKey + "|" + vm.forcedTerm.Value;
                }

                if (crn) {
                    if (typeof (crns[cacheKey]) !== "undefined") {
                        vm.setDisplayText(crns[cacheKey]);
                    } else {
                        if (lookupXhr) {
                            lookupXhr.abort();
                            lookupXhr = null;
                        }
                        var params:any = { crn: crn };
                        if (vm.usingMultipleTerms){
                            params.termCode = vm.selectedTerm();
                        } else {
                            params.termCode = vm.forcedTerm.Value;
                        }


                        lookupXhr = $.get(vm.lookupUrl, params);
                        lookupXhr.done((result, status, jqxhr) => {
                            if (jqxhr === lookupXhr) {
                                if (result && result.Successful) {
                                    crns[cacheKey] = result.Data;
                                } else {
                                    crns[cacheKey] = null;
                                }
                                vm.setDisplayText(crns[cacheKey]);
                            }
                        });
                        lookupXhr.fail((result) => {
                            vm.setDisplayText(null);
                            vm.validationMessage(result.responseJSON.Content);
                        });
                    }
                } else {
                    vm.setDisplayText(null);
                }
            }


            var lookupValueDebounced = _.throttle(actuallyLookupValue, 200);
            var lookupValue = (x) => {
                this.resolving(true);
                lookupValueDebounced();
            }




            var updateTimeout: number;
            var quickStatusUpdateTimeout: number;

            if (!this.disableValidation) {
                ko.computed(() => {
                    this.showStatus(false);
                    this.showQuickStatus(false);
                    this.invalidGroupType(false);
                    if (updateTimeout) {
                        clearTimeout(updateTimeout);
                    }
                    if (quickStatusUpdateTimeout) {
                        clearTimeout(quickStatusUpdateTimeout);
                    }
                    updateTimeout = window.setTimeout(() => {
                            this.showStatus(true);
                        },
                        1000);
                    quickStatusUpdateTimeout = window.setTimeout(() => {
                            this.showQuickStatus(true);
                        },
                        600);

                    var value = this.crn();
                    var term = this.selectedTerm();

                    if (value) {
                        lookupValue(value);
                    } else {
                        this.resetEditor();
                    }
                });
            }
        }       
    }
}